import { useContext } from 'react';
import { ConfigContext } from '../../../../Contexts/ConfigContext';
import { Paper } from '@mui/material';
import CheckBoxInput from '../../../../Components/CheckBoxInput';
import useCommonStyles from '../../../../commonStyles';
import PageHeading from '../../../../Components/PageHeading';

/**
 * @name AutoplayForIos
 * @description This component is an editor for the AutoplayForIos configuration.
 *
 * autoplayForIos: {
 *   "enabled": true
 * }
 *
 * @param {{keyData: 'experimentalFeaturesData.autoplayForIos'}} keyData
 */
const AutoplayForIos = ({ keyData , featureDescription}) => {
	const { rawConfig, updateRawConfig } = useContext(ConfigContext);

	const commonStyleClasses = useCommonStyles();

	return (
		<Paper className={commonStyleClasses.mainPagePaperMarginStyle}>
			<PageHeading
				headingName="Autoplay For Ios"
				headingPath={['Dashboard', 'Framerate', 'Experiments', 'Autoplay For Ios']}
				description="Manage Autoplay For Ios Configuration"
				showInfoButton = {true}
				infoMessage={featureDescription}
			/>

			<CheckBoxInput
				keyData={keyData + '.enabled'}
				label="Enabled"
				disabled={false}
				style={{ marginTop: '6rem', marginLeft: '5rem', width: 'fit-content' }}
				defaultChecked={false}
				object={rawConfig}
				updateObject={updateRawConfig}
			/>
		</Paper>
	);
};

export default AutoplayForIos;
